import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MidAccordionFirstChild from './MidAccordionFirstChild';

const MidAccordionInner = ({
  data = {},
  isAnyCheckBoxChecked,
  updateChildProdDeliverable,
  propData,
  setIsModalMessageOpen,
}) => {
  return (
    <Fragment>
      {data.modules &&
        data.modules.map(item => (
          <MidAccordionFirstChild
            data={item}
            key={item.optionId}
            isAnyCheckBoxChecked={isAnyCheckBoxChecked}
            updateChildProdDeliverable={updateChildProdDeliverable}
            prodData={propData}
            setIsModalMessageOpen={setIsModalMessageOpen}
          />
        ))}
    </Fragment>
  );
};

MidAccordionInner.propTypes = {
  data: PropTypes.shape({}),
  isAnyCheckBoxChecked: PropTypes.func,
  updateChildProdDeliverable: PropTypes.func,
  propData: PropTypes.array,
  setIsModalMessageOpen: PropTypes.func,
};
export default React.memo(MidAccordionInner);
